import "./DiscussionMeta.scss";

export default {
  root: "im-discussion-meta",
  item: "im-discussion-meta__item",
};
